export default {
  account: {},
  address: {},
  contact: {},
  settings: {},
  publicProfile: {},
  businessHours: [],
  businessHourExceptions: [],
  userAppVersion: [],
  userAppToast: '',
  userWidgets: [],
  availableWidgets: [],
  bestClientsWidgets: [],
  waitingProcessedWidgets: 0,
  waitingDeliveredWidgets: 0,
  orderReceivedWidgets: 0,
  revenueWidgets: 0.0,
  popularProductsWidgets: [],
  soldProductsWidgets: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/profile/state.js